import { ToroControllerBundle } from './../../api/models/toro-controller-bundle';
// import { ToroLocationDetailed } from './../../api/models/toro-location-detailed.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ToroLocation } from './../../api/models/toro-location.model';
import { ControllerState } from './controllers/controller.entity';


export interface Irrigation {
    controllers: ToroControllerBundle[];
    selectedController: ToroControllerBundle;
}

// export function selectControllerId(controller: ToroControllerBundle): number {
//     return controller.Controller.Id;
// }

// export interface AccountState extends EntityState<ToroAccountSimple>

export const irrigationAdapter: EntityAdapter<Irrigation> = createEntityAdapter<Irrigation>();

export interface IrrigationState extends EntityState<Irrigation> {
    controllers: ControllerState;
}
